<div class="bg-white rounded-2xl overflow-hidden relative shadow-xl">
  <!-- Header banner -->
  <div
    class="relative px-6 pt-8 pb-7 text-center text-white"
    style="background: linear-gradient(135deg, #FF671D 0%, #FF8A4C 100%);"
    >
    <!-- Close Button -->
    <button
      type="button"
      class="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full text-white/80 hover:bg-white/20 hover:text-white text-2xl leading-none transition-colors"
      (click)="closePopup()"
      aria-label="Close"
      >
      &times;
    </button>

    <div
      class="mx-auto mb-3 w-14 h-14 rounded-full bg-white/20 flex items-center justify-center text-3xl"
      >
      🎁
    </div>
    <h3 class="text-xl tracking-tight font-poppins leading-6 font-bold mb-1">
      You've unlocked a free gift!
    </h3>
    <p class="text-sm font-poppins leading-relaxed font-normal text-white/90">
      Select {{ maxSelections }} free product{{ maxSelections > 1 ? 's' : '' }} below to claim your reward
    </p>
  </div>

  <div class="p-6">
    <div class="max-h-[55vh] overflow-y-auto pr-1">
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        @for (product of data.data.products; track product) {
          <div
            class="group border rounded-xl overflow-hidden cursor-pointer relative transition-all duration-200 bg-white hover:shadow-lg"
            [ngClass]="isSelected(product) ? 'shadow-lg' : 'border-gray-200 hover:border-gray-300'"
            [style.borderColor]="isSelected(product) ? '#FF671D' : ''"
            [style.boxShadow]="isSelected(product) ? '0 0 0 2px #FF671D' : ''"
            (click)="toggleSelection(product)"
            >
            <!-- Selected checkmark badge -->
            @if (isSelected(product)) {
              <div
                class="absolute top-2 right-2 z-10 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold shadow-md"
                style="background-color: #FF671D;"
                >
                ✓
              </div>
            }
            <!-- Product icon area -->
            <div
              class="flex items-center justify-center h-20 text-3xl transition-colors"
              [ngClass]="isSelected(product) ? 'bg-orange-50' : 'bg-gray-50 group-hover:bg-gray-100'"
              >
              🎁
            </div>
            <div class="p-3 text-center">
              <p class="text-sm font-poppins font-medium leading-snug mb-3 line-clamp-2 min-h-[2.5rem] flex items-center justify-center text-gray-800">
                {{ product.productName }}
              </p>
              <button
                type="button"
                class="w-full rounded-full font-semibold py-2 text-xs tracking-wide transition-all"
                [ngClass]="isSelected(product) ? 'text-white' : 'bg-gray-900 text-white group-hover:bg-black'"
                [style.backgroundColor]="isSelected(product) ? '#FF671D' : ''"
                >
                {{ isSelected(product) ? '✓ SELECTED' : 'SELECT' }}
              </button>
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Progress + Claim -->
    <div class="mt-6 text-center">
      <p class="text-sm font-poppins font-semibold mb-4 text-gray-700">
        {{ selectedProducts.length }} / {{ maxSelections }} selected
      </p>

      <button
        type="button"
        [disabled]="selectedProducts.length !== maxSelections || loading"
        (click)="claimGifts()"
        class="px-10 py-3 rounded-full font-poppins font-bold text-sm tracking-wide text-white transition-all shadow-md"
            [ngClass]="selectedProducts.length === maxSelections && !loading
              ? 'cursor-pointer hover:shadow-lg'
              : 'bg-gray-300 cursor-not-allowed opacity-70 shadow-none'"
        [style.backgroundColor]="selectedProducts.length === maxSelections && !loading ? '#FF671D' : ''"
        >
        {{ loading ? 'ADDING...' : 'CLAIM ' + maxSelections + (maxSelections > 1 ? ' GIFTS' : ' GIFT') }}
      </button>
    </div>
  </div>
</div>
